import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LoginApi } from "@/api";
import { setLocalItems } from "@/redux-config/hooks";
import { initialState } from "./state";
import { UserLoginType } from "@/DTO";

export const loginUserAction = createAsyncThunk(
  "user/login",
  async (
    userData: {
      phone: string;
      password: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await LoginApi.FetchUserLogin(
        userData.phone,
        userData.password
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const loginOtpUserAction = createAsyncThunk(
  "user/login-otp",
  async (
    userData: {
      phone: string;
      otp: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await LoginApi.CheckOtp(
        userData.phone,
        userData.otp
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const refreshAction = createAsyncThunk(
  "user/refresh",
  async (userData: UserLoginType, { rejectWithValue }) => {
    try {
      const response = await LoginApi.FetchByRefreshToken(userData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);


export const userSlice = createSlice({
  initialState: initialState,
  name: "User/slice",
  reducers: {},
  extraReducers(builder) {
    builder.addCase(loginUserAction.fulfilled, (state, action) => {
      setLocalItems(
        "user",
        JSON.stringify(action.payload, (key, value) => {
          return value;
        })
      );
      state.value = action.payload;
    });
    builder.addCase(loginOtpUserAction.fulfilled, (state, action) => {
      setLocalItems(
        "user",
        JSON.stringify(action.payload, (key, value) => {
          return value;
        })
      );
      state.value = action.payload;
    });
    builder.addCase(refreshAction.fulfilled, (state, action) => {
      setLocalItems(
        "user",
        JSON.stringify(action.payload, (key, value) => {
          return value;
        })
      );
      state.value = action.payload;
    });
  }
});

export const UserReducer = userSlice.reducer;
